// extracted by mini-css-extract-plugin
module.exports = {"root":"Category_root__3Dokd","label":"Category_label__APGFb","content":"Category_content__3x8tu","header":"Category_header__3ykqU","location":"Category_location__1W8Q1"};